module.exports = __webpack_public_path__ + "static/media/r.ef95b59e.svg";